export default {
  INFORMACASTRECIPIENTGROUP_LIST (state, value) {
    state.list = (value && Array.isArray(value)) ? [...(value.sort((a, b) => a.name.localeCompare(b.name)))] : []
  },
  INFORMACASTRECIPIENTGROUP_LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, Object.assign(state.list[index], value))
    } else {
      state.list.push(value)
    }
  },
  INFORMACASTRECIPIENTGROUP_CURRENT (state, value) {
    const props = [
      'dialcode',
      'exclusionary',
      'name',
      'numberOfPhones',
      'numberOfPlugins',
      'numberOfSpeakers',
      'system',
      'syncId',
      'tag',
      'vendorId'
    ]
    if (value) {
      for (const prop of props) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
        }
      }
      for (const prop of ['id', 'active', 'reenableTime']) {
        if (value[prop] !== state.current[prop]) {
          state.current[prop] = value[prop]
          state.update[prop] = value[prop]
        }
      }
    } else {
      state.current = {
        id: '',
        active: false,
        building: '',
        dialcode: '',
        exclusionary: false,
        name: '',
        numberOfPhones: 0,
        numberOfPlugins: 0,
        numberOfSpeakers: 0,
        reenableTime: null,
        system: '',
        syncId: '',
        tag: '',
        vendorId: ''
      }
      state.update = {
        id: '',
        active: false,
        building: '',
        reenableTime: null
      }
    }
  },
  INFORMACASTRECIPIENTGROUP_UPDATE_ACTIVE (state, value) {
    state.update.active = value
  },
  INFORMACASTRECIPIENTGROUP_UPDATE_REENABLE_TIME (state, value) {
    state.update.reenableTime = value
  },
  INFORMACASTRECIPIENTGROUP_UPDATE_BUILDING (state, value) {
    state.update.building = value
  },
  INFORMACASTRECIPIENTGROUP_FETCHING_LIST (state, value) {
    state.fetchingList = value
  }
}
